module.exports = __webpack_public_path__ + "static/img/irole.0378fb2.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/zxrx/irole.png
// module id = gXZt
// module chunks = 7